const DEFAULT_GOOGLE_MAPS_MAP_ID = "DEMO_MAP_ID";

function normaliseGoogleMapsString(value) {
  return typeof value === "string"
    ? value.trim().replace(/^["']|["']$/g, "")
    : "";
}

const rawGoogleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const rawGoogleMapsMapId = process.env.REACT_APP_GOOGLE_MAPS_MAP_ID;

export const GOOGLE_MAPS_API_KEY = normaliseGoogleMapsString(rawGoogleMapsApiKey);
export const GOOGLE_MAPS_MAP_ID =
  normaliseGoogleMapsString(rawGoogleMapsMapId) || DEFAULT_GOOGLE_MAPS_MAP_ID;

export const GOOGLE_MAPS_ENABLED = GOOGLE_MAPS_API_KEY.length > 0;
